import { useState } from 'react';
import "./CreateNewmeeting.scss";
import { ChevronDown, IconLink } from '../../../assets/images';
import PropTypes from 'prop-types';
import CallScheduling from '../../WebChat/ContactInfo/CallScheduling';

function CreateNewmeeting({ handleShowCallScreen }) {
    const [popupShow, setPopupShow] = useState(false);

    return (
        <div className={`create_new_meeting_wraper ${popupShow ? "open" : ""}`}>
            {/* <button onClick={() => setPopupShow(prev => !prev)} type='button' className='create_new_meeting'>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                }}>
                    <div className='links_icon'>
                        <IconLink />
                    </div>
                    <div className='create_meeting_info'>
                        <strong>Create a new meeting or join a scheduled one</strong>
                    </div>
                </div>
                <ChevronDown style={{
                    width: "1.5rem",
                    height: "1.5rem"
                }} />

            </button> */}
            {
                popupShow && (
                    <CallScheduling
                        open={popupShow}
                        onClose={setPopupShow}
                        header="Create a new meeting"
                        description="Anyone with EN Connect can use this link to join this meet. only share it with people you trust."
                        handleShowCallScreen={handleShowCallScreen}
                        showSchedule={false}
                    />
                )
            }
        </div>
    );
}

export default CreateNewmeeting;

CreateNewmeeting.propTypes = {
    meetLinkPopUp: PropTypes.func,
    handleShowCallScreen: PropTypes.func
};
